module.exports = __webpack_public_path__ + "2b19b87497311f1401e79b1dddc99932.svg";